import cn from 'classnames';

import DefaultLink from 'components/common/DefaultLink';
import Text from 'components/common/Text';
import { HOME_CHEF, TEMPO } from 'context/BrandContext';
import { brandData } from 'helpers/BrandData';
import { SIGN_IN_PATH, TERMS_PATH, PRIVACY_POLICY_PATH } from 'lib/constants/routingConstants';

const SignInButtonSection = ({
  brand,
  isUcl,
  onClick,
  showConvenienceClaimSource = false,
  containerClassName = '',
  textClassName = '',
}) => {
  const brandName = brandData(brand)?.displayName;

  return (
    <div className={cn('mb-6 flex', containerClassName)}>
      <div className={cn('py-0', containerClassName)}>
        <Text brandStylesOverrides="textSm text-light text-left" className={textClassName}>
          By continuing, I accept the {brandName}
          <DefaultLink
            isExternal
            to={TERMS_PATH}
            className={cn('textSm px-1 py-0 font-medium underline', textClassName)}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions of Service
          </DefaultLink>
          and
          <DefaultLink
            isExternal
            to={PRIVACY_POLICY_PATH}
            className={cn('textSm py-0 pl-1 pr-0 font-medium underline', textClassName)}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </DefaultLink>
          .
        </Text>
        {!isUcl && (
          <Text
            brandStylesOverrides="textSm text-light text-left"
            className={cn('pt-2', textClassName)}
          >
            Already have an account?
            <DefaultLink
              isExternal
              to={SIGN_IN_PATH}
              className={cn('textSm py-0 pl-1 pr-0 font-medium underline', textClassName)}
              onClick={onClick}
            >
              Log In
            </DefaultLink>
          </Text>
        )}
        {showConvenienceClaimSource && (
          <Text className="textSm pt-4">
            *Source: We are Talker (fka 72Point Inc., OnePoll U.S. & SWNS Media Group), June 2024
          </Text>
        )}
      </div>
    </div>
  );
};

SignInButtonSection.propTypes = {
  brand: PropTypes.oneOf([HOME_CHEF, TEMPO]),
  isUcl: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  showConvenienceClaimSource: PropTypes.bool,
  containerClassName: PropTypes.string,
  textClassName: PropTypes.string,
};

export default SignInButtonSection;
